const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
let { debug = "", locale = "" } = Object.fromEntries(urlParams);
if (!locale) {
  console.warn("Locale not provided, defaulting to 'en-US'");
  locale = "en-US"; // Default locale
}
const lang = locale.split("-")?.[0] || "en";
if (debug) {
  console.debug("translations debug:", JSON.stringify({ lang }));
}

export const translations = {
  en: {
    title: "Therabody - Confirm Account",
    thanks: "Thanks for verifying your account!",
    mobileClose: "You may close this window and return to the app.",
    shopifyClose: "You may close this window and return to the site.",
    expired: "This confirmation link has expired.",
    checkEmail: "Please check your email for a more recent confirmation link.",
    resendEmail: "Send new link",
    emailResent: "New email sent",
    emailSent: "Email sent",
    error: "Oops there was an error trying to confirm this account!",
  },
  es: {
    title: "Therabody - Confirmar Cuenta",
    thanks: "¡Gracias por verificar tu cuenta!",
    mobileClose: "Puedes cerrar esta ventana y volver a la aplicación.",
    shopifyClose: "Puedes cerrar esta ventana y volver al sitio.",
    expired: "Este enlace de confirmación ha expirado.",
    checkEmail:
      "Por favor revisa tu email para obtener un enlace de confirmación más reciente.",
    resendEmail: "Enviar nuevo enlace",
    emailResent: "Nuevo email enviado",
    emailSent: "Email enviado",
    error: "¡Vaya, hubo un error al intentar confirmar esta cuenta!",
  },
  fr: {
    title: "Therabody - Confirmer le Compte",
    thanks: "Merci d'avoir vérifié votre compte !",
    mobileClose: "Vous pouvez fermer cette fenêtre et revenir à l'application.",
    shopifyClose: "Vous pouvez fermer cette fenêtre et revenir au site.",
    expired: "Ce lien de confirmation a expiré.",
    checkEmail:
      "Veuillez vérifier votre e-mail pour un lien de confirmation plus récent.",
    resendEmail: "Envoyer un nouveau lien",
    emailResent: "Nouvel e-mail envoyé",
    emailSent: "e-mail envoyé",
    error:
      "Oups, une erreur s'est produite lors de la confirmation de ce compte!",
  },
  de: {
    title: "Therabody - Konto Bestätigen",
    thanks: "Danke, dass Sie Ihr Konto bestätigt haben!",
    mobileClose:
      "Sie können dieses Fenster schließen und zur App zurückkehren.",
    shopifyClose:
      "Sie können dieses Fenster schließen und zur Website zurückkehren.",
    expired: "Dieser Bestätigungslink ist abgelaufen.",
    checkEmail:
      "Bitte überprüfen Sie Ihre E-Mails auf einen aktuelleren Bestätigungslink.",
    resendEmail: "Neuen Link senden",
    emailResent: "Neue E-Mail gesendet",
    emailSent: "E-Mail gesendet",
    error:
      "Oops, bei der Bestätigung dieses Kontos ist ein Fehler aufgetreten!",
  },
  it: {
    title: "Therabody - Conferma Account",
    thanks: "Grazie per aver verificato il tuo account!",
    mobileClose: "Puoi chiudere questa finestra e tornare all'app.",
    shopifyClose: "Puoi chiudere questa finestra e tornare al sito.",
    expired: "Questo link di conferma è scaduto.",
    checkEmail: "Controlla la tua email per un link di conferma più recente.",
    resendEmail: "Invia nuovo collegamento",
    emailResent: "Nuova email inviata",
    emailSent: "Email inviata",
    error:
      "Oops, si è verificato un errore durante la conferma di questo account!",
  },
};

const t = (key) =>
  translations[lang]?.[key] || translations.en[key] || `${lang}:${key}`;

export default t;
